import { render, staticRenderFns } from "./VideoStreamMedia.vue?vue&type=template&id=8d79476c"
import script from "./VideoStreamMedia.vue?vue&type=script&lang=ts"
export * from "./VideoStreamMedia.vue?vue&type=script&lang=ts"
import style0 from "./VideoStreamMedia.vue?vue&type=style&index=0&id=8d79476c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports